import { createSelector } from 'reselect'
import { isLoyaltyLoungePassItem } from 'lib/checkout/checkoutUtils'

const getIsLoyaltyFreeLoungePassBenefitPurchase = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items) => {
    return items.length > 0 && items.every(item => isLoyaltyLoungePassItem(item) && item.isFree)
  },
)

export default getIsLoyaltyFreeLoungePassBenefitPurchase
